import Joi from "joi";

export const settingsValidation = Joi.object({
  title: Joi.string().required().min(3).max(255).messages({
    "string.empty": `Title cannot be empty`,
    "string.min": `Title should be at least {#limit} characters long`,
    "string.max": `Title should not be more than {#limit} characters`,
    "any.required": `Title is a required field`,
  }),

  logo: Joi.any().required().messages({
    "any.required": `Logo is a required field`,
  }),

  shortDescription: Joi.string().min(1).max(500).required().messages({
    "any.required": `Short Description is a required field`,
    "string.min": `Short Description cannot be empty`,
    "string.max": `Short Description should not be more than {#limit} characters`,
    "string.empty": `Short Description cannot be empty`,
  }),

  longDescription: Joi.string().min(1).max(500).required().messages({
    "any.required": `Long Description is a required field`,
    "string.min": `Long Description cannot be empty`,
    "string.max": `Long Description should not be more than {#limit} characters`,
    "string.empty": `Long Description cannot be empty`,
  }),

  bppId: Joi.string().required().messages({
    "any.required": `BPP ID is a required field`,

    "string.empty": `BPP ID cannot be empty`,
  }),

  bppUrl: Joi.string().uri().required().messages({
    "any.required": `BPP URL is a required field`,
    "string.uri": `BPP URL must be a valid URL`,
    "string.empty": `BPP URL cannot be empty`,
  }),

  locality: Joi.string().required().messages({
    "string.empty": `Locality cannot be empty`,

    "any.required": `Locality is a required field`,
  }),

  street: Joi.string().required().messages({
    "string.empty": `Street cannot be empty`,

    "any.required": `Street is a required field`,
  }),

  city: Joi.string().required().messages({
    "string.empty": `City cannot be empty`,

    "any.required": `City is a required field`,
  }),

  state: Joi.string().required().messages({
    "string.empty": `State cannot be empty`,

    "any.required": `State is a required field`,
  }),
  country: Joi.string().required().messages({
    "string.empty": `Country cannot be empty`,

    "any.required": `Country is a required field`,
  }),

 pincode: Joi.string()
  .required()
  .pattern(/^\d{6}$/)
  .messages({
    "any.required": `Area Code is a required field`,
    "string.empty": `Area Code cannot be empty`,
    "string.pattern.base": `Area Code should be exactly 6 digits`,
  }),

  storeEmail: Joi.string()

    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.email": `Store Email must be a valid email address`,
      "any.required": `Store Email is a required field`,
      "string.empty": `Store Email cannot be empty`,
    }),

  storeContactNo: Joi.string()
    .required()
    .min(10)
    .max(15)
    .pattern(/^\d+$/)
    .messages({
      "string.empty": `Store Contact No cannot be empty`,
      "string.min": `Store Contact No should be at least {#limit} characters long`,
      "string.max": `Store Contact No should not exceed {#limit} characters`,
      "string.pattern.base": `Store Contact No should only contain digits`,
      "any.required": `Store Contact No is a required field`,
    }),

  authorizedPersonName: Joi.string().required().min(3).messages({
    "string.empty": `Authorized Person Name cannot be empty`,
    "string.min": `Authorized Person Name should be at least {#limit} characters long`,
    "any.required": `Authorized Person Name is a required field`,
  }),

  dateOfIncorporation: Joi.date().required().messages({
    "date.base": `Date of Incorporation must be a valid date`,
    "any.required": `Date of Incorporation is a required field`,
  }),

  panNumber: Joi.string().required().length(10).messages({
    "string.empty": `PAN Number cannot be empty`,
    "string.length": `PAN Number should be exactly {#limit} characters long`,
    "any.required": `PAN Number is a required field`,
  }),

  nameAsPerPAN: Joi.string().required().messages({
    "string.empty": `Name as per PAN cannot be empty`,
    "any.required": `Name as per PAN is a required field`,
  }),

  gstNumber: Joi.string().min(15).max(15).required().messages({
    "any.required": `GST Number is a required field`,
    "string.empty": `GST Number cannot be empty`,
    "string.min": `GST Number should be at least {#limit} characters long`,
    "string.max": `GST Number should not exceed {#limit} characters`,
  }),

  beneficiaryName: Joi.string().required().messages({
    "string.empty": `Beneficiary Name cannot be empty`,
    "any.required": `Beneficiary Name is a required field`,
  }),

  accountNumber: Joi.string()
    .required()
    .min(10)
    .max(20)
    .pattern(/^\d+$/)
    .messages({
      "string.empty": `Account Number cannot be empty`,
      "string.min": `Account Number should be at least {#limit} characters long`,
      "string.max": `Account Number should not exceed {#limit} characters`,
      "string.pattern.base": `Account Number should only contain digits`,
      "any.required": `Account Number is a required field`,
    }),
ifscCode: Joi.string()
  .required()
  .pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/)
  .messages({
    "string.empty": `IFSC Code cannot be empty`,
    "any.required": `IFSC Code is a required field`,
    "string.pattern.base": `IFSC Code must be 11 characters: first 4 alphabets, then 0, then 6 alphanumeric characters`,
  }),


  bankName: Joi.string().required().messages({
    "string.empty": `Bank Name cannot be empty`,
    "any.required": `Bank Name is a required field`,
  }),

  branch: Joi.string().required().messages({
    "string.empty": `Branch cannot be empty`,
    "any.required": `Branch is a required field`,
  }),
});
